import PropTypes from "prop-types";
import React from "react";
import { Input } from "reactstrap";

const ClubbieInput = ({
  type = "text",
  value,
  onChange,
  placeholder = "",
  className = "",
  containerClassName = "",
  innerRef = null,
  ...props
}) => {
  return (
    <div className={`${containerClassName}`}>
      <Input
        type={type}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        className={`clubbie-input ${className}`}
        innerRef={innerRef}
        {...props}
        onWheel={(e) => type === "number" && e.target.blur()}
      />
    </div>
  );
};

ClubbieInput.propTypes = {
  type: PropTypes.string,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  className: PropTypes.string,
  containerClassName: PropTypes.string,
  innerRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.any }),
  ]),
};

export default ClubbieInput;
